<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from "vue-sonner";

const props = defineProps<ToasterProps>();
</script>

<template>
    <Sonner class="toaster group" v-bind="props" :toast-options="{
        classes: {
            toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-text group-[.toaster]:border-border group-[.toaster]:shadow-lg',
            description: 'group-[.toast]:text-text',
            actionButton:
                'group-[.toast]:bg-primary group-[.toast]:text-text',
            cancelButton:
                'group-[.toast]:bg-muted group-[.toast]:text-text',
        },
    }" />
</template>
